import { OrderedMap } from 'immutable';
export default ((EntityRecord, getId, entities) => entities.reduce((entityMap, currentEntity) => {
  const immutableEntity = new EntityRecord(currentEntity);
  return entityMap.set(getId(immutableEntity), immutableEntity);
}, OrderedMap()));